import { getCurrentWindow } from "../utils/window";
export function doOpenUrlForPCDocClient(targetUrl, options) {
  var replace = options.replace,
      windowFeatures = options.windowFeatures,
      windowName = options.windowName,
      supportIFrame = options.supportIFrame;
  var currentWindow = getCurrentWindow(supportIFrame); // window 桌面版新开页面的话，需要增加参数处理

  if (replace) {
    currentWindow.location.href = targetUrl;
  } else {
    currentWindow.open(addFromParam(targetUrl, 'opennew=1'), windowName, windowFeatures);
  }
}
/**
 * 给 url 追加参数
 * @param url  https://docs.qq.com?a=1
 * @param param  b = 2
 * @returns {*} https://docs.qq.com?a=1&b=2
 */

function addFromParam(url, param) {
  var theUrl = url;

  if (!param) {
    return theUrl;
  }

  if (theUrl.indexOf('?') >= 0) {
    theUrl += "&".concat(param);
  } else {
    theUrl += "?".concat(param);
  }

  return theUrl;
}